export default __webpack_public_path__ + "icon-strongher@2x.a0babc1f.png";